import React from 'react';
import cx from 'classnames';

import styles from './QuotesIcon.module.scss';

interface IQuotesIconProps {
  useTextColor?: boolean;
}

export const QuotesIcon: React.FC<IQuotesIconProps> = ({ useTextColor }) => (
  <svg
    className={cx(styles.quoteIcon, useTextColor && styles.quoteIconUseTextColor)}
    width="24"
    height="18"
    viewBox="0 0 24 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.8186 16.4483C14.4701 15.0086 13.7461 13.3937 13.7461 10.776C13.7461 6.16977 16.9629 2.04124 21.6409 0L22.8101 1.81356C18.4437 4.18776 17.5901 7.2687 17.2497 9.21123C17.9527 8.84536 18.8731 8.7177 19.7752 8.80193C22.1371 9.02172 23.9989 10.9708 23.9989 13.3937C23.9989 14.6154 23.5161 15.787 22.6567 16.6509C21.7974 17.5147 20.6318 18 19.4165 18C18.0117 18 16.6684 17.3551 15.8186 16.4483Z" />
    <path d="M2.07255 16.4483C0.72402 15.0086 0 13.3937 0 10.776C0 6.16977 3.21685 2.04124 7.89482 0L9.06399 1.81356C4.69762 4.18776 3.84398 7.2687 3.50357 9.21123C4.20664 8.84536 5.12705 8.7177 6.02913 8.80193C8.39103 9.02172 10.2528 10.9708 10.2528 13.3937C10.2528 14.6154 9.77001 15.787 8.91064 16.6509C8.05127 17.5147 6.88572 18 5.67039 18C4.26556 18 2.92226 17.3551 2.07255 16.4483Z" />
  </svg>
);
